import { render, staticRenderFns } from "./ruralBox.vue?vue&type=template&id=0f228f3f&scoped=true"
import script from "./ruralBox.vue?vue&type=script&lang=js"
export * from "./ruralBox.vue?vue&type=script&lang=js"
import style0 from "./ruralBox.vue?vue&type=style&index=0&id=0f228f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f228f3f",
  null
  
)

export default component.exports